$('.reviews-slider').slick({
  dots: false,
  infinite: true,
  autoplay: false,
  autoplaySpeed: 3000,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});

$('.video-slider').slick({
  dots: false,
  infinite: true,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  slidesToShow: 3,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        centerMode: true
      }
    }
  ]
});

$('.unlock_images').slick({
  dots: false,
  infinite: true,
  prevArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M39.5 8L1.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M8.5 1L1.5 8L8.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  nextArrow: '<span class="arrows"><svg class="review-svg" width="40" height="16" viewBox="0 0 40 16" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="icon"><path class="review-svg" id="Vector" d="M0.5 8L38.5 8" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linejoin="round"/><path id="Vector_2" d="M31.5 1L38.5 8L31.5 15" stroke="white" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/></g></svg></span>',
  arrows: false,
  autoplay: true,
  autoplaySpeed: 3000,
  slidesToShow: 5,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    }
  ]
});

// Get the faqs
var faqBtn = document.querySelectorAll('[data-faq]');

// When the user clicks the button, open the modal 
for (let i = 0; i < faqBtn.length; i++) {
  faqBtn[i].onclick = function() {
  var targetFaq = faqBtn[i].getAttribute('target-faq');
  var faq = document.getElementById(targetFaq);
  faq.classList.toggle("hide");
}
}


// Get the modal
var modals = document.querySelectorAll('.modal')
  
var modalClose = document.querySelectorAll('.modal .close')
var modalBoxClose = document.querySelectorAll('.modal .close-box')

// Get the button that opens the modal
var modalBtn = document.querySelectorAll('[data-modal]');
var modalBoxBtn = document.querySelectorAll('[data-box-modal]');

// When the user clicks the button, open the modal 
for (let i = 0; i < modalBtn.length; i++) {
  modalBtn[i].onclick = function() {
  var targetModal = modalBtn[i].getAttribute('target-modal');
  var modal = document.getElementById(targetModal);
  modal.style.display = "block";
  document.body.classList.add('modal-open');
	  
  var targetDataSource = modalBtn[i].getAttribute('data-source');
  var targetDataVideo = modalBtn[i].getAttribute('data-video');
  
  if (targetDataSource === 'youtube') {
	if (document.querySelector('script[src="https://www.youtube.com/player_api"]') === null) {
		var tag = document.createElement('script');
		tag.src = "https://www.youtube.com/player_api";
		var firstScriptTag = document.getElementsByTagName('script')[0];
		firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
	}
	//var data_video = param.getAttribute('data-video');
	var player;
	function onYouTubePlayerAPIReady(id) {
		player = new YT.Player(id, {
			videoId: id.split('-')[0],
			playerVars: {
				'autoplay': 1,
				'showinfo': 0
			}
		});
	}
	document.querySelector('.video-holder').setAttribute('id',targetDataVideo)
	setTimeout(function() {
		onYouTubePlayerAPIReady(targetDataVideo);
	}, 1000)
  } else if (targetDataSource === 'shopify') {
	  	var hostedVideo = document.createElement('video');
		hostedVideo.src = targetDataVideo;
	  	hostedVideo.setAttribute("controls", "controls");
	    document.querySelector('.video-holder').appendChild(hostedVideo);
		hostedVideo.autoplay = true;
  }
}
}

function setupModalBox() {
  if (window.innerWidth > 767) {
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = function() {
        var targetModal = modalBoxBtn[i].getAttribute('target-modal');
        var modal = document.getElementById(targetModal);
        modal.style.display = "block";
        document.body.classList.add('modal-open');

        var targetDataImage = modalBoxBtn[i].getAttribute('data-image');

        var hostedImage = document.createElement('img');
        hostedImage.src = targetDataImage;
        document.querySelector('.box-holder').appendChild(hostedImage);
      }
    }
  } else {
    // If the screen is smaller than 767px, you might want to remove any existing click event handlers
    // and hide any displayed modals.
    for (let i = 0; i < modalBoxBtn.length; i++) {
      modalBoxBtn[i].onclick = null;
    }
  }
}

// Call the setup function when the page loads
window.addEventListener('load', setupModalBox);

// Call the setup function when the window is resized
window.addEventListener('resize', setupModalBox);

// When the user clicks on <span> (x), close the modal  
for (let i = 0; i < modalClose.length; i++) {
modalClose[i].onclick = function() {
  var closeTargetModal = modalClose[i].getAttribute('target-modal');
  var closeModal = document.getElementById(closeTargetModal);
  closeModal.style.display = "none";
  document.body.classList.remove('modal-open');
  document.querySelector('.video-holder').remove();
  var videoHolder = document.createElement("div");
  videoHolder.classList.add('video-holder') 
  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);
}
} 


/*==================Jquery Cookie Start===========*/
(function(factory) {
        	if (typeof define === 'function' && define.amd) {
            	// AMD (Register as an anonymous module)
            	define(['jquery'], factory);
        	} else if (typeof exports === 'object') {
            	// Node/CommonJS
            	module.exports = factory(require('jquery'));
        	} else {
            	// Browser globals
            	factory(jQuery);
        	}
    	}(function($) {

        	var pluses = /\+/g;

        	function encode(s) {
            	return config.raw ? s : encodeURIComponent(s);
        	}

        	function decode(s) {
            	return config.raw ? s : decodeURIComponent(s);
        	}

        	function stringifyCookieValue(value) {
            	return encode(config.json ? JSON.stringify(value) : String(value));
        	}

        	function parseCookieValue(s) {
            	if (s.indexOf('"') === 0) {
                	// This is a quoted cookie as according to RFC2068, unescape...
                	s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
            	}

            	try {
                	// Replace server-side written pluses with spaces.
                	// If we can't decode the cookie, ignore it, it's unusable.
                	// If we can't parse the cookie, ignore it, it's unusable.
                	s = decodeURIComponent(s.replace(pluses, ' '));
                	return config.json ? JSON.parse(s) : s;
            	} catch (e) {}
        	}

        	function read(s, converter) {
            	var value = config.raw ? s : parseCookieValue(s);
            	return $.isFunction(converter) ? converter(value) : value;
        	}

        	var config = $.cookie = function(key, value, options) {

            	// Write

            	if (arguments.length > 1 && !$.isFunction(value)) {
                	options = $.extend({}, config.defaults, options);

                	if (typeof options.expires === 'number') {
                    	var days = options.expires,
                        	t = options.expires = new Date();
                    	t.setMilliseconds(t.getMilliseconds() + days * 864e+5);
                	}

                	return (document.cookie = [
                    	encode(key), '=', stringifyCookieValue(value),
                    	options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
                    	options.path ? '; path=' + options.path : '',
                    	options.domain ? '; domain=' + options.domain : '',
                    	options.secure ? '; secure' : ''
                	].join(''));
            	}

            	// Read

            	var result = key ? undefined : {},
                	// To prevent the for loop in the first place assign an empty array
                	// in case there are no cookies at all. Also prevents odd result when
                	// calling $.cookie().
                	cookies = document.cookie ? document.cookie.split('; ') : [],
                	i = 0,
                	l = cookies.length;

            	for (; i < l; i++) {
                	var parts = cookies[i].split('='),
                    	name = decode(parts.shift()),
                    	cookie = parts.join('=');

                	if (key === name) {
                    	// If second argument (value) is a function it's a converter...
                    	result = read(cookie, value);
                    	break;
                	}

                	// Prevent storing a cookie that we couldn't decode.
                	if (!key && (cookie = read(cookie)) !== undefined) {
                    	result[name] = cookie;
                	}
            	}

            	return result;
        	};

        	config.defaults = {};

        	$.removeCookie = function(key, options) {
            	// Must not alter options, thus extending a fresh object...
            	$.cookie(key, '', $.extend({}, options, {
                	expires: -1
            	}));
            	return !$.cookie(key);
        	};

    	}));



(function() {
        	var deadline = new Date();
        	deadline.setMinutes(deadline.getMinutes() + 5);
        	var date = $.cookie('date');
        	if (date == undefined) {

            	$.cookie('year', deadline.getFullYear());
            	$.cookie('month', deadline.getMonth());
            	$.cookie('date', deadline.getDate());
            	$.cookie('hours', deadline.getHours());
            	$.cookie('minutes', deadline.getMinutes());
            	$.cookie('seconds', deadline.getSeconds());
        	}

        	if (date == undefined) {} else {
            	deadline.setFullYear($.cookie('year'));
            	deadline.setMonth($.cookie('month'));
            	deadline.setDate($.cookie('date'));
            	deadline.setHours($.cookie('hours'));
            	deadline.setMinutes($.cookie('minutes'));
            	deadline.setSeconds($.cookie('seconds'));

        	}

        	var currentTime = new Date();
        	var timeDifference = deadline.getTime() - currentTime.getTime();
        	if (timeDifference <= 0) {

            	deadline = new Date();
            	deadline.setMinutes(deadline.getMinutes() + 5);
            	$.cookie('year', deadline.getFullYear());
            	$.cookie('date', deadline.getDate());
            	$.cookie('hours', deadline.getHours());
            	$.cookie('minutes', deadline.getMinutes());
            	$.cookie('seconds', deadline.getSeconds());
            	$.cookie('month', deadline.getMonth());
        	}

        	function pad(num, size) {
            	var s = "0" + num;
            	return s.substr(s.length - size);
        	}

        	function getTimeRemaining(endtime) {
            	var t = Date.parse(endtime) - Date.parse(new Date()),
                	seconds = Math.floor((t / 1000) % 60),
                	minutes = Math.floor((t / 1000 / 60) % 60),
                	hours = Math.floor((t / (1000 * 60 * 60)) % 24),
                	days = Math.floor(t / (1000 * 60 * 60 * 24));

            	return {
                	'total': t,
                	'days': days,
                	'hours': hours,
                	'minutes': minutes,
                	'seconds': seconds
            	};
        	}
        	
            var $js_clock_hero_01 = $('.js-clock-hero_01');
        	function clock_hero_01(id, endtime) {
           	 
            	var days = document.getElementById(id + '-days'),
            	hours = document.getElementById(id + '-hours'),
                	minutes = document.getElementById(id + '-minutes'),
                	seconds = document.getElementById(id + '-seconds');

            	var days_2 = document.getElementById(id + '-days'),
            	hours_2 = document.getElementById(id + '-hours'),
                	minutes_2 = document.getElementById(id + '-minutes'),
                	seconds_2 = document.getElementById(id + '-seconds');

            	var timeinterval = setInterval(function() {
                	var t = getTimeRemaining(endtime);

                	if (t.total <= 0) {
                    	clearInterval(timeinterval);
                    	/*===========================================================*/
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	$.cookie('year', deadline.getFullYear());
                    	$.cookie('date', deadline.getDate());
                    	$.cookie('hours', deadline.getHours());
                    	$.cookie('minutes', deadline.getMinutes());
                    	$.cookie('seconds', deadline.getSeconds());
                    	$.cookie('month', deadline.getMonth());
                    	clock('js_clock_hero_01', deadline);
                    	/*===========================================================*/
                    	/*clearInterval(timeinterval);
                    	deadline = new Date();
                    	deadline.setMinutes(deadline.getMinutes() + 5);
                    	clock('js-clock', deadline);*/

                	} else {
                 	 
                  	$.each($js_clock_hero_01, function(index){
                   	 
                  	});
                  	$.each($js_clock_hero_01, function(index){
                    	$(this).find('#' + id + '-days').html(pad(t.days, 2));
                    	$(this).find('#' + id + '-hours').html(pad(t.hours, 2));
                    	$(this).find('#' + id + '-minutes').html(pad(t.minutes, 2));
                    	$(this).find('#' + id + '-seconds').html(pad(t.seconds, 2));                   	 
                  	});
                   	 
                	}
            	}, 1000);
        	}
        	clock_hero_01('js-clock-hero_01', deadline);

			
    	})();
   	 /*================Countdown Timer End===============*/




// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  for (let i = 0; i < modals.length; i++) {
    if ( (event.target == modals[i]) || (event.target.className == "modal-content") ) {
      modals[i].style.display = "none";
      
      document.body.classList.remove('modal-open');
	  document.querySelector('.video-holder').remove();
	  var videoHolder = document.createElement("div");
	  videoHolder.classList.add('video-holder') 
	  document.querySelector('#videoModal .modal-content').appendChild(videoHolder);

    }
  }
}

document.addEventListener('DOMContentLoaded', function () {
    const floatDownload = document.querySelector('.float-download');

    window.addEventListener('scroll', function () {
      if (window.scrollY > 0) {
        floatDownload.style.display = 'flex';
      } else {
        floatDownload.style.display = 'none';
      }
    });
  });